import { useNavigate } from 'react-router-dom';
import { Button, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: { padding: theme.spacing(8), maxWidth: 640 },
  actions: { marginTop: theme.spacing(3) },
}));

/**
 * Shown for unknown pages and for catalog entities that do not exist (or that the user cannot
 * see). Deliberately offers only a way back into the portal - the stock Backstage page links out
 * to backstage.io docs and a support URL that mean nothing to our users.
 */
export function NotFound({
  title = "We couldn't find that page",
  message = 'It may have been deleted, or you may not have access to it.',
}: {
  title?: string;
  message?: string;
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div className={classes.root} data-testid="not-found">
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1">{message}</Typography>
      <div className={classes.actions}>
        <Button
          onClick={() => navigate('/')}
          variant="contained"
          color="primary"
          data-testid="not-found-home"
        >
          Back to home
        </Button>
      </div>
    </div>
  );
}
